import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=5462759f&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=5462759f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462759f",
  null
  
)

export default component.exports